import { Component } from '@angular/core';

@Component({
  selector: 'curbnturf-checked',
  templateUrl: './checked.component.html',
  styleUrls: ['./checked.component.scss'],
  standalone: true,
})
export class CheckedComponent {}
